<div class="side-nav-header">
  <img (click)="viewModel.logoClicked()" [src]="'assets/logo/light/logo-filled.svg'" alt="logo" class="nav-logo" />
  <svg
    (click)="toggleCollapsed.emit()"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none">
    <path
      d="M15.833 3.33301C17.2136 3.33301 18.3328 4.45245 18.333 5.83301V14.167C18.3328 15.5476 17.2136 16.667 15.833 16.667H4.16699C2.78639 16.667 1.66717 15.5476 1.66699 14.167V5.83301C1.66717 4.45245 2.78639 3.33301 4.16699 3.33301H15.833ZM4.16699 5C3.70686 5 3.33318 5.37292 3.33301 5.83301V14.167C3.33318 14.6271 3.70686 15 4.16699 15H6.66699V5H4.16699ZM8.33301 15H15.833C16.2931 15 16.6668 14.6271 16.667 14.167V5.83301C16.6668 5.37292 16.2931 5 15.833 5H8.33301V15ZM13.5342 7.20117C13.6788 7.05653 13.914 7.05653 14.0586 7.20117C14.2029 7.34572 14.2028 7.58003 14.0586 7.72461L11.7275 10.0557L14.0586 12.3867C14.2028 12.5313 14.2029 12.7657 14.0586 12.9102C13.914 13.0548 13.6788 13.0548 13.5342 12.9102L10.9414 10.3174C10.7971 10.1728 10.7972 9.93853 10.9414 9.79395L13.5342 7.20117Z"
      fill="white" />
  </svg>
</div>
